/* Press feedback on the anchor stays in color. Radix measures the trigger when the panel opens, so a scaled trigger would move the panel. */
.anchor:active:not(:disabled) { transform: none; }
.content {
  --popover-x: 0px;
  --popover-y: -5px;
  z-index: 80;
  min-width: 12rem;
  max-width: min(22rem, calc(100vw - 20px));
  padding: 1rem;
  border: 1px solid var(--arc-border);
  border-radius: var(--radius);
  color: var(--arc-foreground);
  box-shadow: var(--arc-shadow-floating);
  transform-origin: var(--radix-popover-content-transform-origin);
  transition: opacity var(--arc-duration-fast) var(--arc-ease-enter), transform var(--arc-duration-spring) var(--arc-ease-spring);
}
/* The panel starts a few pixels toward its trigger and settles on a spring; it leaves faster than it arrives.
   Transitions instead of keyframes, so a close that interrupts the open, or a reopen during the close, reverses from where the panel is. */
.content[data-side="top"] { --popover-y: 5px; }
.content[data-side="left"] { --popover-x: 5px; --popover-y: 0px; }
.content[data-side="right"] { --popover-x: -5px; --popover-y: 0px; }
@starting-style {
  .content[data-state="open"] { opacity: 0; transform: translate(var(--popover-x), var(--popover-y)) scale(.97); }
}
/* Radix unmounts when the exit animation ends, so a no-op keyframe times the exit while the transition does the visual work. */
.content[data-state="closed"] { opacity: 0; transform: translate(calc(var(--popover-x) * .5), calc(var(--popover-y) * .5)) scale(.98); transition: opacity var(--arc-duration-fast) var(--arc-ease-standard), transform var(--arc-duration-fast) var(--arc-ease-standard); animation: popover-exit var(--arc-duration-fast) linear both; pointer-events: none; }
.content:focus { outline: none; }
/* UBM (lot E, 06/10/2026) — la MÊME règle de fond peint le panneau et la flèche d'une façade (Radix Arrow) : aucune
   géométrie ici, la flèche garde sa forme et sa place ; `.content` rend exactement la valeur source. */
.content, .arrow { background: var(--arc-surface-raised); }
.arrow { display: block; }
@keyframes popover-exit { to { --popover-exit: 1; } }
@media (prefers-reduced-motion: reduce) {
  .content, .content[data-state="closed"] { transform: none; transition: opacity var(--arc-duration-instant) var(--arc-ease-standard); }
}
/* UBM (lot U2) — même réduction sous le marqueur manuel `data-motion="reduced"` (scène galerie ou racine portée). */
[data-motion="reduced"] .content, .content[data-motion="reduced"], [data-motion="reduced"] .content[data-state="closed"], .content[data-state="closed"][data-motion="reduced"] { transform: none; transition: opacity var(--arc-duration-instant) var(--arc-ease-standard); }

/* Explicit font contract: a portal must not depend on its DOM ancestry. */
.content{font-family:var(--font-family);font-size:var(--arc-text-sm);font-weight:400;line-height:1.5;letter-spacing:var(--arc-tracking-body)}
